import React, { Component, PropTypes } from 'react';
import CompleteLevelModal from './completeLevelModal';
import programs from 'programs';

export default class CompleteLevelButton extends Component {

  static contextTypes = {
    sessionId: PropTypes.string.isRequired,
    session: PropTypes.object.isRequired,
    completeLevelAndExit: PropTypes.func.isRequired,
    completeLevelPreview: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  openModal () {
    const {
      session: {
        currentLevel,
        completedLevel
      }
    } = this.context;
    if (Number(currentLevel) < completedLevel) {
      this.exitNoComplete();
      return;
    }
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  complete () {
    const {
      completeLevelAndExit,
      sessionId,
      session: {
        programId,
        currentLevel,
        contractId,
        funding,
        completedLevel
      }
    } = this.context;
    const program = programs.programLookup[programId];
    const { levels } = program;
    let finished = false;
    const nextLevel = String(Number(currentLevel) + 1);
    if (!levels[nextLevel]) {
      finished = true;
    }

    completeLevelAndExit({
      sessionId,
      completedLevel: currentLevel,
      programId,
      finished,
      contractId,
      funding,
      previousCompletedLevel: completedLevel
    });
  }

  exitNoComplete () {
    const {
      completeLevelPreview,
      sessionId,
      session: {
        programId,
        currentLevel,
        contractId,
        funding
      }
    } = this.context;
    completeLevelPreview({
      sessionId,
      completedLevel: currentLevel,
      programId,
      contractId,
      funding
    });
  }

  render () {
    const { session, i18n: _ } = this.context;
    const { showModal } = this.state;
    return (
      <div>
        <button
            className="btn btn-lg btn-primary clickToEndLevel"
            onClick={::this.openModal}>
          {_('Click to Complete Level')}
        </button>
        <CompleteLevelModal
            session={session}
            showModal={showModal}
            closeModal={::this.closeModal}
            complete={::this.complete}
            exitNoComplete={::this.exitNoComplete} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/completeLevelButton.js